<template>
  <div v-if="visibleAddHomeScreenIos">
    <div class="instalar">
      <p @click="close()">
        Pulsa
        <img src="@/assets/share-ico.png" style="width:25px;" /> en tu
        dispositivo y después "Añadir a pantalla de inicio" para instalar MMT
        Seguros
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mostrar: true,
    };
  },

  computed: {
    userAgente() {
      return window.navigator.userAgent.toLowerCase();
    },

    platform() {
      return window.navigator.platform;
    },

    isIos() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return (
        /iphone|ipad|ipod/.test(userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      );
    },

    isInStandaloneMode() {
      return "standalone" in window.navigator && window.navigator.standalone;
    },

    visibleAddHomeScreenIos() {
      return this.isIos && !this.isInStandaloneMode && this.mostrar;
    },
  },

  methods: {
    close() {
      this.mostrar = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.instalar {
  font-size: 100%;
  font-weight: bold;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  padding-bottom: 10px;
  background-color: white;
  z-index: 2000;
  text-align: center;
  margin: auto;
}
</style>
